window.addEventListener('show-export-calculation-modal', event => {
    $('#exportCalculationModal').modal('show');
});
